import React from 'react';
import Icon from './Icon';
import SectionHeading from './SectionHeading';
import { whyInterscope } from '../mock/mock';

export default function WhyInterscope() {
  return (
    <section className="relative max-w-7xl mx-auto px-5 md:px-8 section-pad">
      <SectionHeading
        eyebrow="Why Interscope"
        title="Why Brands Choose Interscope"
        subtitle="Confident, business-focused performance — not generic agency promises."
      />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {whyInterscope.map((w) => (
          <div key={w.title} className="reveal group relative overflow-hidden rounded-2xl glass glass-hover p-7">
            <div className="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-[#2563eb]/10 blur-2xl group-hover:bg-[#2563eb]/20 transition-colors" />
            <div className="relative">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#2563eb]/20 to-[#1d4ed8]/20 grid place-items-center text-[#2563eb] mb-5 group-hover:scale-110 transition-transform">
                <Icon name={w.icon} size={24} />
              </div>
              <h3 className="font-display text-lg font-semibold text-slate-900 mb-2">{w.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed">{w.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
